import { Button, Flex, Space, Descriptions } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { useState } from "react";
import intl from 'react-intl-universal';
import _ from 'lodash-es';
import request from "../../../libs/request";

const submitData = async (data) => {
    var res = await request.post(`${window.base_url}/api_v3/visits`, {
        intakeId: _.get(data, "intake.value.id"),
        member_id: window.user.id,
        slot_start: _.get(data, "calendar_picker.value.slot_start"),
        slot_end: _.get(data, "calendar_picker.value.slot_end"),
        type: window.CONST.VISIT.TYPE.SCHEDULED,
        room_code: _.get(data, "room.value.code")
    });
    return res["data"] ? res["data"] : res;
}

const Confirmation = ({currentComponent, onNext, onPrevious, room, data, reservationRef, isMobileWebview}) => {
    const [loading, setLoading] = useState(false);
    const confirmed = _.get(data, "confirmation.value.id") != null;
    const items = [
        {
            key: '1',
            label: 'Location',
            children: _.get(data, "room.value.name", ""),
        },
        {
            key: '2',
            label: 'Time',
            children: _.get(data, "calendar_picker.value.slot_start", ""),
        },
        {
            key: '3',
            label: 'Reason for visit',
            children: _.get(data, "intake.value.reason_for_visit", ""),
        },
        {
            key: '4',
            label: 'Patient Name',
            children: _.get(window, "user.full_name", ""),
        }
    ];

    return (
        <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
            <Descriptions items={ items } column={1}/>
            <Flex justify={isMobileWebview ? "center" : "space-between"}>
                { (onPrevious != null && !confirmed && !isMobileWebview) ?
                    <Button onClick={ onPrevious }>
                        <LeftOutlined style={{ verticalAlign:"middle" }} />
                        {intl.get("back").d("Back")}
                    </Button> : <div></div>
                }
                <Button
                    type="primary"
                    loading={loading}
                    shape={isMobileWebview ? "round" : "default"}
                    size={isMobileWebview ? "large" : "default"}
                    onClick={() => {
                        if (confirmed) {
                            onNext();
                            return;
                        }
                        setLoading(true);
                        submitData(data).then((res) => {
                            onNext(res);
                            if (reservationRef.current) {
                                reservationRef.current.removeReservation();
                            }
                        }).finally(() => {
                            setLoading(false);
                        });
                    }
                }>
                    {confirmed ? intl.get("done").d("Done") : intl.get("book_visit").d("Book Visit")}
                    <RightOutlined style={{verticalAlign:"middle"}} />
                </Button>
            </Flex>
        </Space>
    );
}

export default Confirmation;